<template>
<div style="display: flex;">
  <el-dialog
    title="导出日志"
    :visible.sync="dialogFormVisible"
    width="900px"
    :before-close="close"
  >
     <el-autocomplete
        style="width:170px; margin-right:15px;"
        v-model="mac"
        :fetch-suggestions="querymacSearch"
        placeholder="MAC地址"
      ></el-autocomplete>
      <el-select style="width:170px; margin-right:15px;" v-model="cloud">
        <el-option
          v-for="platform in platforms"
          :key="platform"
          :label="platform"
          :value="platform"
        >
        </el-option>
      </el-select>
      <el-autocomplete
        v-if="cloud === '手动指定云服务IP'"
        style="width:200px; margin-right:15px;"
        v-model="ip"
        :fetch-suggestions="queryipSearch"
        placeholder="手动指定云服务IP"
      ></el-autocomplete>
      <el-button @click="queryDevice" type="primary" size="small"
        >查询设备</el-button
      >
        <div style="display: flex;margin:30px  0px;">
      <el-tag size="medium" class="tag" type="primary">设备在线状态</el-tag>
      <i v-if="isOnline" class="el-icon-circle-check success"></i>
      <i v-else class="el-icon-circle-close error "></i>
      <el-tag size="medium" class="tag" type="primary">告警通道状态</el-tag>
      <el-switch
        v-model="isChannel"
        active-color="#67C23A"
        :disabled="!isOnline"
        style="margin:10px  0px;margin-right:10px;"
        @change="changeChannel"
      ></el-switch>
      <template>
        <el-tag size="medium" class="tag" type="primary" style="width:140px;"
          >接入服务器地址</el-tag
        >
        <label
          for="final.server_ip"
          style="margin:5px  0px;margin-right:20px;"
          >{{ final.server_ip }}</label
        >
        <el-tag size="medium" class="tag" type="primary">dclient_ver</el-tag>
        <label
          for="final.dclient_ver"
          style="margin:7px  0px;margin-right:20px;"
          >{{ final.dclient_ver }}</label
        >
      </template>
    </div>
       <el-button
          @click="exportLog"
          type="primary"
          size="medium"
          :disabled="!isOnline"
          class="task"
          >导出日志</el-button
        >
          <el-input
          v-model="logtaskName"
          class="taskcontent"
          placeholder="任务名称"
        ></el-input>
         <template>
        <el-tag size="medium" class="tag" type="primary" style="width:140px;"
          >任务状态</el-tag
        >
        <!-- <label
          for="final.server_ip"
          style="margin:5px  0px;margin-right:20px;"
          >{{ flagName }}</label
        > -->
         <el-tag
                    type="info"
                    v-if="flagName === '进行中'"
                    >{{ flagName }}</el-tag
                  >
                  <el-tag
                    type="success"
                    v-else-if="flagName=== '已完成'"
                    >{{ flagName }}</el-tag
                  >
        <i 
          v-if="flag!==''"
          class="el-icon-refresh-left size"
          @click="reflashStatus()"
                  />
      </template>
      

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" :disabled="!isExport" @click="download()">下载日志</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import { Alarmstatus, alarmstatusList } from "@/components/Index/data.js";
import { Flags} from "../Index/data.js";
export default {
  props: {
    macdata:{}
  },
  data() {
    return {
      dialogFormVisible: true,
      Alarmstatus: Alarmstatus,
      alarmstatusList: alarmstatusList,
      value: "",
      mac:"",
      cloud: "",
      dclient_ver: "",
      username: "",
      server_ip: "",
      location: "",
      logtaskName:"",
      flag:"",
      flagName:"",
       platforms: [
        "ucloud",
        "ecloud",
        "scloud",
        "sacloud",
        "t-healthcare",
        "test_kyy",
        "dev_sh",
        "dev_hz",
        "jcloud",
        "ccloud",
        "aucloud",
        "azcloud",
        "rucloud",
        "discreet",
        "discreet2025",
        "ecloud-tis",
        "dev",
        "test",
        "test84",
        "test_hz",
        "test_hager",
        "手动指定云服务IP"
      ],
      isOnline: false,
      isChannel: false,
      isExport: false,
      statusData:"",
       final: {
        task_type: "",
        name: "",
        create_time: "",
        mac: "",
        cloud: "",
        dclient_ver: "",
        username: "",
        server_ip: "",
        location: ""
      }
    };
  },
  mounted() {
    // this.initForm.alarm_status = this.initForm.alarm_status.toString();
      this.mac=this.macdata.mac;
      this.cloud=this.macdata.cloud;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    download() {
      
        window.location.href = this.statusData[0].file_url;
    },
    reflashStatus(){
         this.$http["get"](
          "tasks/", {},
          (data) => {
            this.statusData=data.data.results;  
                    this.flag=this.statusData[0].flag;
                    this.flagName=Flags[this.flag];
                    if( this.flagName==="已完成"){
                      this.isExport=true;
                    }
          }
        );

    },
     querymacSearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      const macRecords = JSON.parse(localStorage.getItem("macRecord"));
      const results = queryString
        ? macRecords.filter(this.createmacFilter(queryString))
        : macRecords;
      cb(results);
    },
     queryDevice() {
      if (this.mac.match(/[A-F0-9a-f]{12}/)) {
        this.macRecords = this.setmacIntoStorage();
        this.ipRecords = this.setipIntoStorage();
        this.$http["get"](
          "devices/",
          { mac: this.mac, cloud: this.cloud, ip: this.ip },
          data => {
            this.openChannel = true;
            this.final.mac = data.data.mac;
            this.final.cloud = data.data.cloud;
            this.final.dclient_ver = data.data.dclient_ver;
            this.final.server_ip = data.data.server_ip;
            //is_connect为1 在线
            if (data.data.is_connect) {
              this.isOnline = true;
              if (data.data.alarm_channel_status) {
                this.isChannel = true;
              }
            } else {
              this.$message("当前设备不在线，请开启第2维护通道进行操作！");
              this.isOnline = false;
              this.isChannel = false;
            }
          },
          () => {
            this.openChannel = false;
            this.isOnline = false;
            this.isChannel = false;
            this.final.mac = "";
            this.final.cloud = "";
            this.final.dclient_ver = "";
            this.final.server_ip = "";
          }
        );
      } else {
        this.$message.error("请输入正确格式的MAC地址");
      }
    },
    changeChannel() {
      //打开告警通道
      if (this.isChannel) {
        this.$http["post"](
          "device_alarm_channels/",
          {
            operation: "open",
            mac: this.final.mac,
            cloud: this.final.cloud,
            server_ip: this.final.server_ip,
            is_close: "1"
          },
          () => {
            this.$baseNotice.message("开启成功");
          },
          () => {
            this.isChannel = !this.isChannel;
          }
        );
      }
      //关闭告警通道
      else {
        this.$http["post"](
          "device_alarm_channels/",
          {
            operation: "close",
            mac: this.final.mac,
            cloud: this.final.cloud,
            server_ip: this.final.server_ip,
            is_close: "0"
          },
          () => {
            this.$baseNotice.message("关闭成功");
          },
          () => {
            this.isChannel = !this.isChannel;
          }
        );
      }
    },
     setmacIntoStorage() {
      // localStorage.removeItem("macRecord");
      const noArr = []; // 历史记录数组
      const value = this.mac;
      const macRecord = "macRecord";
      noArr.push({ value: value, type: macRecord });
      if (JSON.parse(localStorage.getItem(macRecord))) {
        // 判断是否已有xxx查询记录的localStorage
        if (localStorage.getItem(macRecord).indexOf(value) > -1) {
          // 判断是否已有此条查询记录，若已存在，则不需再存储
          return;
        }
        if (JSON.parse(localStorage.getItem(macRecord)).length >= 5) {
          const arr = JSON.parse(localStorage.getItem(macRecord));
          arr.pop();
          localStorage.setItem(macRecord, JSON.stringify(arr));
        }
        localStorage.setItem(
          macRecord,
          JSON.stringify(
            noArr.concat(JSON.parse(localStorage.getItem(macRecord)))
          )
        );
      } else {
        // 首次创建
        localStorage.setItem(macRecord, JSON.stringify(noArr));
      }
    },
    setipIntoStorage() {
      // localStorage.removeItem("ipRecord");
      const noArr = []; // 历史记录数组
      const value = this.ip;
      const ipRecord = "ipRecord";
      noArr.push({ value: value, type: ipRecord });
      if (JSON.parse(localStorage.getItem(ipRecord))) {
        // 判断是否已有xxx查询记录的localStorage
        if (localStorage.getItem(ipRecord).indexOf(value) > -1) {
          // 判断是否已有此条查询记录，若已存在，则不需再存储
          return;
        }
        if (JSON.parse(localStorage.getItem(ipRecord)).length >= 5) {
          const arr = JSON.parse(localStorage.getItem(ipRecord));
          arr.pop();
          localStorage.setItem(ipRecord, JSON.stringify(arr));
        }
        localStorage.setItem(
          ipRecord,
          JSON.stringify(
            noArr.concat(JSON.parse(localStorage.getItem(ipRecord)))
          )
        );
      } else {
        // 首次创建
        localStorage.setItem(ipRecord, JSON.stringify(noArr));
      }
    },
     exportLog() {
      if (this.logtaskName) {
        this.final.task_type = "1";
        this.final.name = this.logtaskName;
        this.final.create_time = this.changeDate(new Date());
        this.final.username = localStorage.getItem("username");
        this.$http["post"]("tasks/", this.final, () => {
          this.$baseNotice.message("创建成功");
          this.updateList++;
          this.$http["get"](
          "tasks/", {},
          (data) => {
            this.statusData=data.data.results;  
                    this.flag=this.statusData[0].flag;
                    console.log(this.flag);
                    this.flagName=Flags[this.flag];
                    console.log(this.flagName);
          }
        );
        });
      } else {
        this.$message.error("请输入任务名称！");
      }
    },
      changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
     timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>
<style lang="less" scoped>
.size {
  font-size: 24px;
  margin-left: 20px;
}
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 10px;
  padding: 0px 16px;
  text-align: center;
}
.error {
  font-size: 25px;
  color: #606266;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 20px;
}
.success {
  font-size: 25px;
  color: #67c23a;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 20px;
}
.task {
  width: 120px;
  margin-right: 20px;
  margin-top: 15px;
}
.taskcontent {
  width: 300px;
  margin-right: 20px;
  margin-top: 15px;
}
.input {
  border-radius: 5px;
  border: 1px solid #ff0000;
}
</style>

